import { Grid } from "swiper/modules";
import "../styles/CabAbout.scss";
import useGetUserProfile from "../hooks/useGetUserProfile";
//import MarginBox from '../../../shared/components/other/MarginBox';

//На будущее:

/* 1. Надо что-то придумать с ссылкой на модалку в боксах с камуфляжем и командой: 
надо либо во всех боксах делать ссылку на модалку ближе к правому нижнему углу (визуально не очень), 
либо контент сделать в боксах сделать ближе к заголовку, примерно как название команды в блоксе "команда". 
Вообще это задача дизайнеров*/

const CabAbout = ({ username,  data, isLoading, error  }: any) => {

  // const dataAbout = {
  //     "user_callsign": "Позывной",
  //     "team": {
  //       "name": "Тестовая команда",
  //       "avatar_link": "https://media.cybershtab.ru/cybershtab-local-bucket/images/teams/avatars/6d588e0c-6bea-446e-85f1-149df9d8dc8e.jpg",
  //       "slug": "13158-testovaia-komanda"
  //     },
  //     "region_name": "Санкт-Петербург и ЛО",
  //     "user_about": "Обо мне",
  //     "user_main_spec": {
  //       "name": "Снайпер",
  //       "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/users/specialisations/1a3374cb-ffb0-47e4-94cc-fc8c3a6a4c76.jpg"
  //     },
  //     "user_camouflages": [
  //       {
  //         "name": "Ночь",
  //         "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/camouflages/f783f09c-c87b-4965-a499-da7968d7d821.jpg"
  //       },
  //       {
  //         "name": "Темный лес",
  //         "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/camouflages/9b1ca931-2100-4dcb-ad81-02c540726b24.jpg"
  //       }
  //     ],
  //     "user_main_weapon": {
  //       "name": "Моя винтовка",
  //       "type": {
  //         "name": "Винтовка",
  //         "image": "https://media.cybershtab.ru/cybershtab-local-bucket/images/weapon/type/8d155f01-738d-4e26-94d7-225270d69643.jpg"
  //       },
  //       "firm_name": "Тестовый производитель"
  //     }
  // }

  return (
    <>
      <div className="aboutMe">
        <h1>О себе</h1>
        <p>{data?.user_about}</p>
      </div>
      <div className="aboutComponents">
        <div className="cabinet_beautyBorder specialisation">
          <h1>Специализация</h1>
          <div className="container-for-img">
            <img
              className="sp-mw-bg"
              src="\CabAbout\background-net.svg"
              alt=""
            ></img>
            <img
              className="sp-mw-img"
              src={data?.user_main_spec?.image || '/CabAbout/sniper.svg'}
              alt={data?.user_main_spec?.name}
            ></img>
          </div>
          <p>{data?.user_main_spec?.name}</p>
          {/* <a href="/" className="modal">Eщё 2</a> */}
        </div>
        <div className="container">
          <div className="cabinet_beautyBorder camouflage">
            <h1>Камуфляж</h1>
            <div className="camoufList">
              {data?.user_camouflages?.map((camouflage: any) => (
                <img
                  src={camouflage.image}
                  alt=""
                  className="camouf_n"
                  key={camouflage.name}
                  title={camouflage.name}
                ></img>
              ))}
            </div>
          </div>
          <div className="cabinet_beautyBorder achievements">
            <h1>Достижения</h1>
            <p>Раздел в разработке</p>
          </div>
        </div>
        <div className="container">
          <div className="cabinet_beautyBorder team">
            <div className="teamContainer">
              <h1>Команда</h1>
              <p>{data?.team?.name}</p>
            </div>
            <img
              className="teamAvatar"
              src={data?.team?.avatar_link|| '/CabAbout/Airsoft-team.png' }
              alt=""
            ></img>
          </div>
          <div className="cabinet_beautyBorder market">
            <h1>Рынок</h1>
            <p>Раздел в разработке</p>
          </div>
        </div>
        <div className="cabinet_beautyBorder mainWeapon">
          <h1>Основной привод</h1>
          <div className="container-for-img">
            <img
              className="sp-mw-bg"
              src="\CabAbout\background-net.svg"
              alt=""
            ></img>
            <img
              className="sp-mw-img"
              src={data?.user_main_weapon?.type?.image || '/CabAbout/AR-15.svg'}
              alt={data?.user_main_weapon?.type?.name}
            ></img>
          </div>
          <p>{data?.user_main_weapon?.name}</p>
          {/* <a href="/" className="modal">Ещё 2</a> */}
        </div>
      </div>
      <hr></hr>
    </>
  );
};

export default CabAbout;
